import React, {useEffect} from "react";
import {Container} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {ShipmentActions} from "../../Store/Shipments/Slice";
import {RootState} from "../../Store/Reducers";
import ShipmentHistoryTableComponent from "./ShipmentHistoryTableComponent";

const HistoryComponent = () => {

  const dispatch = useDispatch();

  const {CompanyReducer: {branch_selected, company_selected}} = useSelector((state: RootState) => state);

  useEffect(() => {
    if (branch_selected || company_selected) {
      dispatch(ShipmentActions.getShipments({}));
    }
  }, [dispatch, branch_selected, company_selected]);

  return (
    <div className="p-5">
      <Container>
        <ShipmentHistoryTableComponent/>
      </Container>
    </div>
  );
};

export default HistoryComponent;
